import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function DownloadFileButton(props: {
  buttonLabel: string
  fileName: string
  fileLink: string
  downloadErrorMessage?: string
}) {
  const context = useWebAppContext()
  const errorT = useTranslation('errors')
  return (
    <Button
      label={props.buttonLabel}
      text
      icon='pi pi-download'
      iconPos='left'
      onClick={async () => {
        const fileResp = await context?.httpClient?.downloadFile({ input: props.fileLink }, props.fileName)
        if (fileResp?.fetchError || fileResp?.blobError || !fileResp?.httpResponse || !fileResp.httpResponse.ok) {
          context.showToastMessage({
            severity: 'error',
            summary: props.downloadErrorMessage ?? errorT.t('DownloadFileErrorMessage'),
          })
        }
      }}
    ></Button>
  )
}
